// import React, { useState, useCallback } from "react";
// import { MainLayout } from "../layout/MainLayout";
// import {
//   Card,
//   FormInput,
//   Button,
//   Alert,
//   FormGroup,
// } from "../ui/base-components";

// const DeleteUserComponent = () => {
//   const apiRoot = process.env.REACT_APP_API_ROOT;
//   const [formData, setFormData] = useState({
//     userSearchQuery: "",
//     selectedUserId: "",
//     selectedUserEmail: "",
//   });
//   const [users, setUsers] = useState([]);
//   const [message, setMessage] = useState({ type: "", text: "" });

//   const debounce = (func, delay) => {
//     let timeoutId;
//     return (...args) => {
//       clearTimeout(timeoutId);
//       timeoutId = setTimeout(() => func(...args), delay);
//     };
//   };

//   const fetchUsers = useCallback(
//     async (query = "") => {
//       try {
//         if (query.length < 3) {
//           setUsers([]);
//           return;
//         }

//         const response = await fetch(`${apiRoot}/api/user?search=${query}`, {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });
//         const data = await response.json();
//         const formattedUsers = data.map((user) => ({
//           value: user.id,
//           label: user.email,
//         }));

//         setUsers(formattedUsers);
//       } catch (error) {
//         setMessage({ type: "error", text: "Error searching users" });
//       }
//     },
//     [apiRoot]
//   );

//   const debouncedUserSearch = useCallback(
//     debounce((query) => {
//       if (query.length >= 3) {
//         fetchUsers(query);
//       } else {
//         setUsers([]);
//       }
//     }, 300),
//     [fetchUsers]
//   );

//   const handleChange = (e) => {
//     const { id, value } = e.target;
//     setFormData((prev) => {
//       if (id === "userSearchQuery") {
//         debouncedUserSearch(value);
//       }

//       return {
//         ...prev,
//         [id]: value,
//         ...(id === "userSearchQuery" && {
//           selectedUserId: "",
//           selectedUserEmail: "",
//         }),
//       };
//     });
//   };

//   const handleUserSelect = (userId, userEmail) => {
//     setFormData((prev) => ({
//       ...prev,
//       selectedUserId: userId,
//       selectedUserEmail: userEmail,
//       userSearchQuery: userEmail,
//     }));
//     setUsers([]);
//   };

//   const handleDelete = async () => {
//     const confirmDelete = window.confirm(
//       `Are you sure you want to delete the user with email ${formData.selectedUserEmail}?`
//     );

//     if (!confirmDelete) return;

//     try {
//       const response = await fetch(
//         `${apiRoot}/user/delete/?email=${encodeURIComponent(
//           formData.selectedUserEmail
//         )}`,
//         {
//           method: "DELETE",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );

//       if (response.ok) {
//         setMessage({
//           type: "success",
//           text: `User with email ${formData.selectedUserEmail} has been deleted successfully.`,
//         });

//         setFormData({
//           userSearchQuery: "",
//           selectedUserId: "",
//           selectedUserEmail: "",
//         });
//       } else {
//         const errorData = await response.json();
//         setMessage({
//           type: "error",
//           text: errorData.error || "Failed to delete the user",
//         });
//       }
//     } catch (error) {
//       setMessage({
//         type: "error",
//         text: "An error occurred while deleting the user",
//       });
//     }
//   };

//   return (
//     <MainLayout>
//       <div className="p-6 mt-4">
//         <div className="max-w-md mx-auto">
//           <Card>
//             <div className="space-y-6">
//               <div>
//                 <h2 className="text-2xl font-bold text-gray-900">
//                   Delete User
//                 </h2>
//                 <p className="mt-1 text-sm text-gray-600">
//                   Search and delete a user from the system.
//                 </p>
//               </div>

//               {message.text && (
//                 <Alert type={message.type} message={message.text} />
//               )}

//               <FormGroup>
//                 <div className="space-y-2">
//                   <FormInput
//                     id="userSearchQuery"
//                     label="Search User"
//                     type="text"
//                     placeholder="Type at least 3 characters to search"
//                     value={formData.userSearchQuery}
//                     onChange={handleChange}
//                   />

//                   {users.length > 0 && (
//                     <div className="border border-gray-300 rounded-md shadow-sm max-h-48 overflow-y-auto">
//                       {users.map((user) => (
//                         <div
//                           key={user.value}
//                           onClick={() =>
//                             handleUserSelect(user.value, user.label)
//                           }
//                           className="px-3 py-2 hover:bg-gray-100 cursor-pointer 
//                             transition-colors duration-200 
//                             border-b border-gray-200 last:border-b-0"
//                         >
//                           {user.label}
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   {formData.selectedUserEmail && (
//                     <div className="mt-2 text-sm text-gray-700">
//                       Selected User: {formData.selectedUserEmail}
//                     </div>
//                   )}
//                 </div>
//               </FormGroup>

//               <Button
//                 variant="danger"
//                 className="w-full"
//                 onClick={handleDelete}
//                 disabled={!formData.selectedUserId}
//               >
//                 Delete User
//               </Button>
//             </div>
//           </Card>
//         </div>
//       </div>
//     </MainLayout>
//   );
// };

// export default DeleteUserComponent;
import React, { useState, useCallback } from "react";
import { MainLayout } from "../layout/MainLayout";
import {
  Trash2,
  Search,
  User,
  AlertCircle,
  CheckCircle2,
  AlertTriangle,
  Loader
} from "lucide-react";

const DeleteUserComponent = () => {
  const apiRoot = process.env.REACT_APP_API_ROOT;
  const [formData, setFormData] = useState({
    userSearchQuery: "",
    selectedUserId: "",
    selectedUserEmail: "",
  });
  const [users, setUsers] = useState([]);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isSearching, setIsSearching] = useState(false);

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func(...args), delay);
    };
  };

  const fetchUsers = useCallback(
    async (query = "") => {
      try {
        if (query.length < 3) {
          setUsers([]);
          setIsSearching(false);
          return;
        }

        setIsSearching(true);
        const response = await fetch(`${apiRoot}/api/user?search=${query}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        const formattedUsers = data.map((user) => ({
          value: user.id,
          label: user.email,
        }));

        setUsers(formattedUsers);
      } catch (error) {
        setMessage({ type: "error", text: "Error searching users" });
      } finally {
        setIsSearching(false);
      }
    },
    [apiRoot]
  );

  const debouncedUserSearch = useCallback(
    debounce((query) => {
      if (query.length >= 3) {
        fetchUsers(query);
      } else {
        setUsers([]);
        setIsSearching(false);
      }
    }, 300),
    [fetchUsers]
  );

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => {
      if (id === "userSearchQuery") {
        if (value.length >= 3) {
          setIsSearching(true);
        }
        debouncedUserSearch(value);
      }

      return {
        ...prev,
        [id]: value,
        ...(id === "userSearchQuery" && {
          selectedUserId: "",
          selectedUserEmail: "",
        }),
      };
    });
  };

  const handleUserSelect = (userId, userEmail) => {
    setFormData((prev) => ({
      ...prev,
      selectedUserId: userId,
      selectedUserEmail: userEmail,
      userSearchQuery: userEmail,
    }));
    setUsers([]);
    setIsSearching(false);
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm(
      `⚠️ WARNING: This action cannot be undone!\n\nAre you sure you want to permanently delete the user with email "${formData.selectedUserEmail}"?\n\nThis will remove all their data and access permissions.`
    );

    if (!confirmDelete) return;

    setIsLoading(true);
    try {
      const response = await fetch(
        `${apiRoot}/user/delete/?email=${encodeURIComponent(
          formData.selectedUserEmail
        )}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.ok) {
        setMessage({
          type: "success",
          text: `User with email ${formData.selectedUserEmail} has been deleted successfully.`,
        });

        setFormData({
          userSearchQuery: "",
          selectedUserId: "",
          selectedUserEmail: "",
        });
      } else {
        const errorData = await response.json();
        setMessage({
          type: "error",
          text: errorData.error || "Failed to delete the user",
        });
      }
    } catch (error) {
      setMessage({
        type: "error",
        text: "An error occurred while deleting the user",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-8">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
          
          {/* Page Header */}
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-red-600 to-rose-600 rounded-2xl mb-6 shadow-lg">
              <Trash2 className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl font-bold bg-gradient-to-r from-slate-800 to-slate-600 bg-clip-text text-transparent mb-4">
              Delete User
            </h1>
            <p className="text-lg text-slate-600 max-w-xl mx-auto">
              Search and permanently remove a user from the system
            </p>
          </div>

          {/* Warning Notice */}
          <div className="mb-8 bg-amber-50 border border-amber-200 rounded-xl p-4">
            <div className="flex items-center gap-3">
              <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0" />
              <div>
                <h3 className="text-sm font-semibold text-amber-800">Important Warning</h3>
                <p className="text-sm text-amber-700 mt-1">
                  Deleting a user is permanent and cannot be undone. This will remove all their data and access permissions.
                </p>
              </div>
            </div>
          </div>

          {/* Main Form Card */}
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 overflow-hidden">
            {/* Card Header */}
            <div className="bg-gradient-to-br from-red-600 to-rose-600 p-6 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-br from-white/20 to-transparent"></div>
              <div className="relative z-10">
                <div className="flex items-center gap-3">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-white/20 backdrop-blur-sm rounded-xl">
                    <Trash2 className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-white">User Removal</h2>
                    <p className="text-white/80 text-sm">Search and select a user to delete</p>
                  </div>
                </div>
              </div>
              
              {/* Decorative Elements */}
              <div className="absolute -top-8 -right-8 w-24 h-24 bg-white/10 rounded-full"></div>
              <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-white/10 rounded-full"></div>
            </div>

            {/* Card Content */}
            <div className="p-8">
              {/* Alert Messages */}
              {message.text && (
                <div className={`mb-6 p-4 rounded-xl border flex items-center gap-3 ${
                  message.type === "success" 
                    ? "bg-green-50 border-green-200 text-green-700" 
                    : "bg-red-50 border-red-200 text-red-700"
                }`}>
                  {message.type === "success" ? (
                    <CheckCircle2 className="w-5 h-5 flex-shrink-0" />
                  ) : (
                    <AlertCircle className="w-5 h-5 flex-shrink-0" />
                  )}
                  <p className="text-sm font-medium">{message.text}</p>
                </div>
              )}

              <div className="space-y-6">
                {/* User Search */}
                <div>
                  <label
                    htmlFor="userSearchQuery"
                    className="block text-sm font-semibold text-slate-700 mb-2"
                  >
                    Search User
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <Search className="h-5 w-5 text-slate-400" />
                    </div>
                    <input
                      type="text"
                      id="userSearchQuery"
                      value={formData.userSearchQuery}
                      onChange={handleChange}
                      className="w-full pl-10 pr-10 py-3 border border-slate-300 rounded-xl focus:ring-2 
                        focus:ring-red-500 focus:border-red-500 transition-all duration-200 bg-slate-50 focus:bg-white"
                      placeholder="Type at least 3 characters to search users..."
                    />
                    {isSearching && (
                      <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                        <Loader className="h-5 w-5 text-slate-400 animate-spin" />
                      </div>
                    )}
                  </div>
                  <p className="text-sm text-slate-500 mt-1">
                    Enter at least 3 characters to start searching
                  </p>
                </div>

                {/* Search Results */}
                {users.length > 0 && (
                  <div className="border border-slate-200 rounded-xl shadow-sm overflow-hidden">
                    <div className="bg-slate-50 px-4 py-2 border-b border-slate-200">
                      <span className="text-sm font-semibold text-slate-700">Search Results</span>
                    </div>
                    <div className="max-h-48 overflow-y-auto">
                      {users.map((user, index) => (
                        <div
                          key={user.value}
                          onClick={() => handleUserSelect(user.value, user.label)}
                          className={`px-4 py-3 hover:bg-slate-50 cursor-pointer transition-colors duration-200 
                            flex items-center gap-3 ${
                              index !== users.length - 1 ? 'border-b border-slate-100' : ''
                            }`}
                        >
                          <User className="w-4 h-4 text-slate-400" />
                          <span className="text-slate-700">{user.label}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Selected User Display */}
                {formData.selectedUserEmail && (
                  <div className="bg-red-50 border border-red-200 rounded-xl p-4">
                    <h3 className="text-sm font-semibold text-red-700 mb-2 flex items-center gap-2">
                      <User className="w-4 h-4" />
                      Selected User
                    </h3>
                    <div className="bg-white rounded-lg p-3 border border-red-200">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                          <User className="w-4 h-4 text-red-600" />
                        </div>
                        <div>
                          <p className="font-medium text-red-800">{formData.selectedUserEmail}</p>
                          <p className="text-sm text-red-600">ID: {formData.selectedUserId}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Delete Button */}
                <button
                  onClick={handleDelete}
                  disabled={!formData.selectedUserId || isLoading}
                  className="group w-full py-4 px-6 bg-gradient-to-r from-red-600 to-rose-600 hover:from-red-700 hover:to-rose-700 
                    text-white rounded-xl font-semibold transition-all duration-200 flex items-center justify-center gap-3
                    disabled:opacity-50 disabled:cursor-not-allowed shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
                >
                  {isLoading ? (
                    <>
                      <Loader className="w-5 h-5 animate-spin" />
                      Deleting User...
                    </>
                  ) : (
                    <>
                      <Trash2 className="w-5 h-5 group-hover:scale-110 transition-transform duration-200" />
                      Delete User Permanently
                    </>
                  )}
                </button>

                {/* Additional Information */}
                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <h3 className="text-sm font-semibold text-slate-700 mb-3 flex items-center gap-2">
                    <AlertCircle className="w-4 h-4 text-blue-600" />
                    What happens when you delete a user?
                  </h3>
                  <div className="space-y-2 text-sm text-slate-600">
                    <div className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span>User account will be permanently removed</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span>All associated project assignments will be revoked</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span>User data and permissions will be lost</span>
                    </div>
                    <div className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-red-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span>This action cannot be undone</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default DeleteUserComponent;